//App
import { ClaimContext } from "../ClaimContainer";
import { ClaimContextData, ClaimProps } from "../../../../types/claim";
import useForm from "../../../hooks/useForm";

const useClaim = (props: ClaimProps) => {
  return useForm<ClaimContextData, ClaimProps>(ClaimContext, props);
};

export default useClaim;
